/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { HeaderSlot, uniqueID } from "../../../../utils/constants";
import { getOrderList } from "../../../../store/reducers/order";
import Layout from '../../../components/Layout';
import OrderTabs from "../../../components/Orders/OrdersHistoryList/OrdersTabs";
import Loader from "../../../../components/Loader/index";
import NoOrders from "../../../components/Orders/OrdersHistoryList/NoOrders";
import OrderList from "../../../components/Orders/OrdersHistoryList/OrderList";
import {
    authHeaders,
    axiosInstance,
    encodeValue,
    sendAnalyticsPageView,
} from "../../../../utils/helper";
import useNavigation from "../../../../hook/useNavigation";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import Modal from "../../../../components/Modal";
import { RelativeHeader } from '../../../components/Header';

var qs = require("qs");

function OrderHistory() {
    const navigate = useNavigation();

    const { orderType = "all" } = useParams();
    const dispatch = useDispatch();

    const user = useSelector((store) => store?.user);

    const [trigerCart, setTrigerCart] = useState(false);
    const [loading, setLoading] = useState(false);

    const [displayCount, setDisplayCount] = useState(5);
    const [popup, setPopup] = useState({
        show: false,
        confirm: false,
        type: null,
        value: null
    });

    const tab = useSelector((state) => state.order?.tab);

    const all = useSelector((state) => state.order?.all);
    const pending = useSelector((state) => state.order?.pending);
    const delivering = useSelector((state) => state.order?.delivering);
    const processing = useSelector((state) => state.order?.processing);
    const completed = useSelector((state) => state.order?.completed);
    const canceled = useSelector((state) => state.order?.canceled);

    useEffect(() => {
        if (!user?.token) return;
        setLoading(true);
        dispatch(
            getOrderList({
                unquieid: uniqueID,
            })
        ).unwrap()
            .finally(() => {
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.token]);

    useEffect(() => {
        sendAnalyticsPageView("order_history_session");
    }, []);

    const ratingChanged = (orderID, newRating) => {
        console.log("ratingChanged");
        const postObject = {
            unquieid: uniqueID,
            orderID: encodeValue(orderID),
            rating: newRating
        };

        axiosInstance
            .post(`orders/createRating`, qs.stringify(postObject))
            .then((res) => {
                if (res.data.status === "ok") {
                    dispatch(
                        getOrderList({
                            unquieid: uniqueID,
                        })
                    );
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleRemoveCart = async () => {
        console.log("handleRemoveCart");
        try {
            const postData = {
                unquieid: uniqueID,
            };
            const res = await axiosInstance.post(
                `cart/removeCart`,
                qs.stringify(postData),
                authHeaders()
            );
            return res;
        } catch (error) {
            console.log("error: ", error);
        }
    };

    const handleOrderAgain = async (item) => {
        console.log("handleOrderAgain");
        try {
            const removeCart = await handleRemoveCart();
            console.log("removeCart: ", removeCart);
            if (removeCart?.data?.status !== "ok") {
                return;
            }
            const postData = {
                unquieid: uniqueID,
                orderID: encodeValue(item?.order_primary_id)
            };
            const res = await axiosInstance.post(
                `orders/orderAgain`,
                qs.stringify(postData)
            );
            console.log("res: ", res);
            if (res?.data?.status === "ok") {
                navigate.push("/summary");
            }
        } catch (error) {
            console.log("error: ", error);
        }
    };

    const sateValChange = (field, value) => {
        if (field === "trigerCart") {
            setTrigerCart(value);
        }
    };

    const loadMore = () => {
        setDisplayCount((prevCount) => prevCount + displayCount);
    };

    const orderList = useMemo(() => {
      if (tab === 'pesanan') {
        switch (orderType) {
          case 'all':
            return all?.slice(0, displayCount);
          case 'waiting-payment':
            return pending;
          case 'on-process':
            return processing;
          case 'delivering':
            return delivering;
          case 'completed':
            return completed;
          case 'canceled':
            return canceled;
          default:
            return [];
        }
      }
  
      return [];
    }, [tab, orderType, all, pending, processing, delivering, completed, canceled, displayCount]);

    const handlePopup = (type, value) => {
        setPopup((prev) => {
            return {
                ...prev,
                show: true,
                type,
                value
            };
        });
    };

    const handleTracking = (link = "") => {
        if (link) {
            window.open(link, "_blank");
        }
    };

    useEffect(() => {
        if (popup?.confirm && !popup?.show && popup?.type === "tracking") {
            handleTracking(popup?.value);
        }
        if (popup.confirm && !popup?.show) {
            setPopup({
                show: false,
                confirm: false,
                type: null,
                value: null
            });
        }
    }, [popup]);

    const shouldShowLoadMore = useMemo(() => {
        if (tab !== 'pesanan' || orderType !== 'all') return false;

        return displayCount < (all?.length ?? 0);
    }, [tab, orderType, displayCount, all?.length]);

    const headerProps = {
        slots: {
            left: {
              content: HeaderSlot.BACK,
            },
            center: {
              content: HeaderSlot.NAME,
              title: 'Riwayat Pesanan',
              className: '!opacity-100 transform !translate-y-0 ml-2',
            },
            right: null,
        },
        parent: {
          border: {
            bottom: true,
          },
        }
    };

    return (
        <Layout>
            {loading && <Loader overlay />}
            <RelativeHeader {...headerProps} />
            <div className="content-body rel">
                <OrderTabs
                    orderType={orderType}
                    all={tab === "pesanan" ? all?.length : 0}
                    waitingPayment={tab === "pesanan" ? pending?.length : 0}
                    delivering={tab === "pesanan" ? delivering?.length : 0}
                    onprogress={processing?.length}
                    completed={completed?.length}
                    canceled={canceled?.length}
                />
                {!orderList?.length ? (
                    <NoOrders />
                ) : (
                    <>
                        <OrderList
                            orderList={orderList}
                            orderType={orderType}
                            ratingChanged={ratingChanged}
                            orderAgain={handleOrderAgain}
                            handlePopup={handlePopup}
                        />
                        {shouldShowLoadMore && (
                            <div className="w-full flex justify-center py-2">
                                <button
                                    onClick={loadMore}
                                    className="button border-[var(--rose-violet)] bg-[var(--rose-violet)] hover:!bg-[var(--rose-violet)] hover:!border-[var(--rose-violet)]"
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
            {popup?.show && (
                <Modal
                    isOpen={popup?.show}
                    onClose={() => {
                        setPopup({
                            show: false,
                            confirm: false,
                            type: null,
                            value: null
                        });
                    }}
                >
                    <div
                        className={`bg-white px-4 py-8 rounded-xl shadow-custom transition-transform duration-1000 ease-in-out ${popup?.show ? "translate-y-0 relative" : "translate-y-full hidden"}`}
                    >
                        <div className="items-center flex justify-center">
                            <ExclamationCircleIcon className="h-14 w-auto fill-[var(--rose-violet)]" />
                        </div>
                        <div className="my-5 text-center">
                            <div className="text-gray-900 text-sm font-semibold">{`Anda akan diarahkan ke aplikasi ${popup?.type === "call" ? "Telepon" : popup?.type === "tracking" ? "Browser" : "WhatsApp"}`}</div>
                            <div className="text-gray-900 text-xs pt-2">
                                Apakah Anda yakin ingin melanjutkan?
                            </div>
                        </div>
                        <div className="flex justify-between mt-2 gap-4">
                            <button
                                className="w-full bg-white text-[var(--rose-violet)] border-[var(--rose-violet)] font-semibold text-sm p-3 items-center border"
                                onClick={() => {
                                    setPopup({
                                        show: false,
                                        confirm: false,
                                        type: null,
                                        value: null
                                    });
                                }}
                                id="merchant_change_cart_cancel"
                            >
                                Batal
                            </button>
                            <button
                                onClick={() => {
                                    setPopup((prev) => {
                                        return {
                                            ...prev,
                                            show: false,
                                            confirm: true
                                        };
                                    });
                                }}
                                className="w-full bg-[var(--rose-violet)] text-white font-semibold text-sm p-3 items-center border-0"
                                id="merchant_change_cart_confirm"
                            >
                                Ya, Lanjutkan
                            </button>
                        </div>
                    </div>
                </Modal>
            )}
        </Layout>
    );
}

export default OrderHistory;
